// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1UUIU","image":"Header_image__1DOVr","name":"Header_name__OiDi0","info":"Header_info__3fAXH","infoRow":"Header_infoRow__2WJWB"};